/* La etiqueta chica en mayúsculas: 12px semibold, +0.08em. Con `mono`, JetBrains Mono 11 (los rótulos de tokens). */
.eyebrow {
  display: inline-block;
  margin: 0;
  font-family: var(--font-body);
  font-size: var(--fs-2xs);
  font-weight: var(--fw-semibold);
  letter-spacing: var(--ls-eyebrow);
  text-transform: uppercase;
  line-height: var(--lh-normal);
  color: var(--text-muted);
}
.eyebrow[data-mono] {
  font-family: var(--font-mono);
  font-size: var(--fs-3xs);
  font-weight: var(--fw-medium);
}
.eyebrow[data-tone="brand"] {
  color: var(--text-brand);
}
.eyebrow[data-tone="strong"] {
  color: var(--text-strong);
}
